import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { Language } from './Enums/Language'
import daAccounting from '../locales/da/accounting.json'
import daAi from '../locales/da/ai.json'
import daBudget from '../locales/da/budget.json'
import daCommon from '../locales/da/common.json'
import daConfiguration from '../locales/da/configuration.json'
import daDashboard from '../locales/da/dashboard.json'
import daGuide from '../locales/da/guide.json'
import daLogin from '../locales/da/login.json'
import daProfile from '../locales/da/profile.json'
import daSpreadsheet from '../locales/da/spreadsheet.json'
import deAccounting from '../locales/de/accounting.json'
import deAi from '../locales/de/ai.json'
import deBudget from '../locales/de/budget.json'
import deCommon from '../locales/de/common.json'
import deConfiguration from '../locales/de/configuration.json'
import deDashboard from '../locales/de/dashboard.json'
import deGuide from '../locales/de/guide.json'
import deLogin from '../locales/de/login.json'
import deProfile from '../locales/de/profile.json'
import deSpreadsheet from '../locales/de/spreadsheet.json'
import enAccounting from '../locales/en/accounting.json'
import enAi from '../locales/en/ai.json'
import enBudget from '../locales/en/budget.json'
import enCommon from '../locales/en/common.json'
import enConfiguration from '../locales/en/configuration.json'
import enDashboard from '../locales/en/dashboard.json'
import enGuide from '../locales/en/guide.json'
import enLogin from '../locales/en/login.json'
import enProfile from '../locales/en/profile.json'
import enSpreadsheet from '../locales/en/spreadsheet.json'

export const NAMESPACES = [
  'common',
  'profile',
  'login',
  'dashboard',
  'budget',
  'accounting',
  'spreadsheet',
  'configuration',
  'guide',
  'ai',
] as const

// Danish is the source/complete language every string is authored in first;
// German/English are DeepL-generated and may lag behind during development,
// so untranslated keys fall back to Danish instead of showing a raw key.
export const FALLBACK_LANGUAGE = Language.DANISH

i18n.use(initReactI18next).init({
  resources: {
    [Language.DANISH]: {
      common: daCommon,
      profile: daProfile,
      login: daLogin,
      dashboard: daDashboard,
      budget: daBudget,
      accounting: daAccounting,
      spreadsheet: daSpreadsheet,
      configuration: daConfiguration,
      guide: daGuide,
      ai: daAi,
    },
    [Language.GERMAN]: {
      common: deCommon,
      profile: deProfile,
      login: deLogin,
      dashboard: deDashboard,
      budget: deBudget,
      accounting: deAccounting,
      spreadsheet: deSpreadsheet,
      configuration: deConfiguration,
      guide: deGuide,
      ai: deAi,
    },
    [Language.ENGLISH]: {
      common: enCommon,
      profile: enProfile,
      login: enLogin,
      dashboard: enDashboard,
      budget: enBudget,
      accounting: enAccounting,
      spreadsheet: enSpreadsheet,
      configuration: enConfiguration,
      guide: enGuide,
      ai: enAi,
    },
  },
  lng: Language.ENGLISH,
  fallbackLng: FALLBACK_LANGUAGE,
  defaultNS: 'common',
  ns: NAMESPACES,
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
